import { render, staticRenderFns } from "./site-policy.vue?vue&type=template&id=6e45bab8&scoped=true&"
var script = {}
import style0 from "./site-policy.vue?vue&type=style&index=0&id=6e45bab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e45bab8",
  null
  
)

export default component.exports